import { render, staticRenderFns } from "./cardpackage.vue?vue&type=template&id=9431688e&scoped=true&"
import script from "./cardpackage.vue?vue&type=script&lang=js&"
export * from "./cardpackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9431688e",
  null
  
)

export default component.exports